import { get } from 'lodash-es';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { getPageLinksPath, LinkWidgetsModel } from 'client/data/models/link-widgets';
import { pageDefinition } from 'client/site-modules/shared/pages/page';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { getFAQSchema } from 'client/seo/schemas/faq';
import { FAQ_CONTENT } from 'site-modules/editorial/constants/tco-content';
import { Tco, BREADCRUMBS } from './tco';

export const pageDefinitionConfiguration = {
  name: 'other_tco_index',
  category: 'other',
  component: Tco,
  preload: store => {
    const preloader = new ModelPreloader(store);
    preloader.resolve(getPageLinksPath(), LinkWidgetsModel);
    return preloader.load();
  },
  seo: (state, props) => ({
    title: 'Cost of Car Ownership - 5-Year Cost Calculator | Edmunds.com',
    keywords: 'Cost of Car Ownership',
    description:
      'Calculate the cost of owning a car new or used vehicle over the next 5 years. Edmunds True Cost to Own® (TCO®) takes depreciation. loan interest, taxes & fees, fuel, maintenance and repairs into account.',
    jsonld: [
      getBreadcrumbSchema(BREADCRUMBS),
      getFAQSchema({ entries: FAQ_CONTENT, generateLearnMoreLinks: true, pathname: get(props, 'location.pathname') }),
    ],
  }),
};

export default pageDefinition(pageDefinitionConfiguration);
